module.exports = __webpack_public_path__ + "static/media/main_kawan.c12ef579.png";